import React from 'react';
import { 
  FaFlask,
  FaBook,
  FaLaptop,
  FaFutbol,
  FaPalette,
  FaUtensils,
  FaHeartbeat,
  FaLeaf,
  FaTree
} from 'react-icons/fa';

const CampusFacilities = () => {
  const facilities = [
    {
      id: 1,
      title: "Science Labs",
      subtitle: "Well-Equipped Labs",
      description: "Physics, Chemistry, Biology with modern equipment",
      icon: FaFlask,
      bgColor: "bg-blue-50",
      textColor: "text-blue-600"
    },
    {
      id: 2,
      title: "Library",
      subtitle: "Extensive Collection",
      description: "Digital resources & reading zone",
      icon: FaBook,
      bgColor: "bg-purple-50",
      textColor: "text-purple-600"
    },
    {
      id: 3,
      title: "Computer Lab",
      subtitle: "Advanced Systems",
      description: "High-speed internet & latest software",
      icon: FaLaptop,
      bgColor: "bg-indigo-50",
      textColor: "text-indigo-600"
    },
    {
      id: 4,
      title: "Sports Facilities",
      subtitle: "Multiple Sports Options",
      description: "Indoor & outdoor games",
      icon: FaFutbol,
      bgColor: "bg-emerald-50",
      textColor: "text-emerald-600"
    },
    {
      id: 5,
      title: "Art & Music",
      subtitle: "Creative Studios",
      description: "Art, music, dance studios",
      icon: FaPalette,
      bgColor: "bg-amber-50",
      textColor: "text-amber-600"
    },
    {
      id: 6,
      title: "Cafeteria",
      subtitle: "Healthy & Hygienic",
      description: "Nutritious meals & dining area",
      icon: FaUtensils,
      bgColor: "bg-rose-50",
      textColor: "text-rose-600"
    },
    {
      id: 7,
      title: "Medical Room",
      subtitle: "On-Campus Care",
      description: "Trained nurse & first aid",
      icon: FaHeartbeat,
      bgColor: "bg-red-50",
      textColor: "text-red-600"
    },
    {
      id: 8,
      title: "Green Spaces",
      subtitle: "Spacious Campus",
      description: "Gardens & playgrounds",
      icon: FaTree,
      bgColor: "bg-green-50",
      textColor: "text-green-600"
    }
  ];

  return (
    <section className="py-6 bg-white">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto mb-8 text-center">
          <div className="inline-flex items-center px-3 py-1 mb-3 text-xs font-medium rounded-full text-emerald-600 bg-emerald-50">
            <FaLeaf className="w-3 h-3 mr-1.5" />
            Campus Facilities
          </div>
          <h2 className="mb-3 text-2xl font-bold text-gray-900">Modern Infrastructure</h2>
          <p className="text-sm text-gray-600">
            State-of-the-art facilities for comprehensive learning experience
          </p>
        </div>

        {/* Facilities Grid */}
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {facilities.map((facility) => (
            <div
              key={facility.id}
              className="p-4 transition-all duration-300 bg-white border border-gray-100 group rounded-xl hover:shadow-sm hover:border-gray-200"
            >
              {/* Icon Container */}
              <div className={`inline-flex items-center justify-center w-10 h-10 mb-3 rounded-lg ${facility.bgColor}`}>
                <div className={facility.textColor}>
                  <facility.icon className="w-5 h-5" />
                </div>
              </div>

              {/* Content */}
              <div>
                <h3 className="mb-1 text-sm font-bold text-gray-900">{facility.title}</h3>
                <div className="mb-2 text-xs font-medium text-gray-700">{facility.subtitle}</div>
                <p className="text-xs text-gray-600">{facility.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampusFacilities;